import { config } from 'config';

export const LENDING_EXTERNAL_URL = config.api.lendingPartner;
